import styled, { css } from 'styled-components';
import { colors, r4 } from '@ardoq/design-tokens';
import { focusRingCSS } from '@ardoq/style-helpers';
import { text2 } from '@ardoq/typography';

const THUMB_SIZE = 20;
const BAR_HEIGHT = 6;
const SLIDER_HEIGHT = 24;
const VALUE_WIDTH = 24;

export const SliderWrapper = styled.div`
  display: flex;
`;

export const SliderBarWrapper = styled.div`
  flex: 1;
  height: ${SLIDER_HEIGHT}px;
  position: relative;
  min-width: 180px;
`;

export const SliderBar = styled.div<{ $barColor?: string }>`
  position: absolute;
  top: calc(50% - ${BAR_HEIGHT / 2}px);
  background-color: ${({ $barColor }) => $barColor ?? colors.borderAction};
  height: ${BAR_HEIGHT}px;
  width: 100%;
  border-radius: ${r4};
  cursor: pointer;
`;

export const SliderValueBar = styled(SliderBar)<{
  $hasError?: boolean;
  $valueBarColor?: string;
}>`
  background-color: ${({ $hasError, $valueBarColor }) =>
    $hasError ? colors.borderError : ($valueBarColor ?? colors.borderInfo)};
  pointer-events: none;
`;

type GetThumbColorProps = {
  $isDragging?: boolean;
  $hasError?: boolean;
  $thumbColor?: string;
};

const getThumbColor = ({
  $isDragging,
  $hasError,
  $thumbColor,
}: GetThumbColorProps) => {
  if ($hasError && $isDragging) return colors.surfaceActionDeletePressed;
  if ($hasError) return colors.surfaceActionDelete;
  if ($thumbColor) return $thumbColor;
  if ($isDragging) return colors.blue700;
  return colors.blue600;
};

export const SliderThumbCircle = styled.div<
  {
    $isFocused?: boolean;
  } & GetThumbColorProps
>`
  position: absolute;
  top: ${(SLIDER_HEIGHT - THUMB_SIZE) / 2}px;
  margin-left: -${THUMB_SIZE / 2}px;
  height: ${THUMB_SIZE}px;
  width: ${THUMB_SIZE}px;
  background-color: ${getThumbColor};
  border-radius: ${THUMB_SIZE / 2}px;
  cursor: pointer;

  transition: transform 0.1s ease-in-out;
  &:hover {
    transform: scale(1.1);
  }

  ${({ $isFocused }) =>
    $isFocused &&
    css`
      ${focusRingCSS};
      &::before {
        border-radius: ${THUMB_SIZE / 2}px;
      }
    `};
`;

export const SliderValue = styled.div<{ $hasError?: boolean }>`
  ${text2};
  color: ${({ $hasError }) =>
    $hasError ? colors.textError : colors.textDefault};
  min-width: ${VALUE_WIDTH}px;
  margin-left: 12px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InfinitySymbol = styled.div.attrs({ children: '∞' })`
  font-size: 22px;
`;
